import Dashboard from '../pages/Dashboard';
import Participants from '../pages/Participants';
import Scripts from '../pages/Scripts';
import MatchArea from '../pages/MatchArea';
import MatchList from '../pages/MatchList';
import InfoGala from '../pages/InfoGala';
import Affiliazione from '../pages/Affiliazione';
import GestioneParametri from '../pages/GestioneParametri';
import AllMatches from '../pages/AllMatches';
import Matchings from '../pages/Matchings';
import Rankings from '../pages/Rankings';

import { 
  FaHome, 
  FaUsers, 
  FaCode, 
  FaChalkboardTeacher, 
  FaListOl, 
  FaInfoCircle, 
  FaHandshake, 
  FaSlidersH, 
  FaClipboardList, 
  FaPuzzlePiece,
  FaTrophy 
} from 'react-icons/fa';

const routes = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <FaHome />, // overview generale
    component: Dashboard,
    roles: ["admin"],
  },
  {
    name: "Partecipanti",
    path: "/participants",
    icon: <FaUsers />, // gestione partecipanti
    component: Participants,
    roles: ["admin", "coach"],
  },
  {
    name: "Scripts",
    path: "/scripts",
    icon: <FaCode />, // codice o script di gestione
    component: Scripts,
    roles: ["admin"],
  },
  {
    name: "MatchArea",
    path: "/match-area",
    icon: <FaChalkboardTeacher />, // gestione area di gara
    component: MatchArea,
    roles: ["admin", "match_area"], 
  },
/*  {
    name: "MatchList",
    path: "/match-list",
    icon: <FaListOl />, // lista dei match
    component: MatchList,
    roles: ["admin", "match_area", "coach"], 
  },*/
  {
    name: "AllMatches",
    path: "/allMatches",
    icon: <FaClipboardList />, // lista completa dei match
    component: AllMatches,
    roles: ["admin", "match_area", "coach"], 
  },
  /*{
    name: "InfoGala",
    path: "/info-gala",
    icon: <FaInfoCircle />, // informazioni sull’evento/gala
    component: InfoGala,
    roles: ["admin", "coach", "match_area"], 
  },
  {
    name: "Affiliazione",
    path: "/affiliazione",
    icon: <FaHandshake />, // gestione affiliazioni
    component: Affiliazione,
    roles: ["admin", "coach"], 
  },*/
  {
    name: "GestioneParametri",
    path: "/gestione-parametri",
    icon: <FaSlidersH />, // parametri e configurazioni generali
    component: GestioneParametri,
    roles: ["admin"], 
  },
  {
    name: "Classifica",
    path: "/rankings",
    icon: <FaTrophy />, 
    component: Rankings,
    roles: ["admin", "coach", "match_area"], 
  },
];

export default routes;
